import { Component, OnInit } from '@angular/core';
import { NgFlowchartStepComponent } from '../../../../../../projects/ng-flowchart/src/lib/ng-flowchart-step/ng-flowchart-step.component';
import { NgFlowchart } from 'projects/ng-flowchart/src/lib/model/flow.model';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TestService } from 'src/app/_services/test.service';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ConfirmationDialogService } from '../../confirmation-dialog.service';

export type MyForm = {
  input1: string;
};

@Component({
  selector: 'app-form-step2',
  templateUrl: './form-step2.component.html',
  styleUrls: ['./form-step2.component.scss'],
})
export class FormStep2Component
  extends NgFlowchartStepComponent<MyForm>
  implements OnInit
{

  stepRenameForm: FormGroup;
  randomNumber = Math.floor(Math.random() * 10001);
  branchName: string;
  projectId: any;
  testId: any;
  testStepId: any;
  allBranches: any;
  newlyCreatedBranch: any;
  parentStep: NgFlowchartStepComponent<any>;
  url: string;
  testStepdata: any;
  testStep: any;
  testStepCopy: any;
  visibleIndexForCardTip: any;
  autoExecute: any;
  branchCheck: any;
  currentBranches: any = [];

  constructor(private toastrService: ToastrService,
     private formBuilder: FormBuilder,
     private testService: TestService,
    private route:ActivatedRoute,
    private http: HttpClient,
    private confirmationDialogService: ConfirmationDialogService,) {
    super();
    this.url = environment.baseUrl
    this.route.paramMap.subscribe(
      params => {
        this.projectId = params.get('pid');
        this.testId = params.get('tid');
        this.testStepId = params.get('tsid')
        // var res = JSON.parse(localStorage.getItem('projectDataById'));
        this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
        subscribe(
          (data) => {
            let currentBranchIds = [];
            this.testStepdata = data;
            this.testStep = this.testStepdata.teststepList;
            this.testStepCopy = JSON.parse(JSON.stringify(this.testStep));
            for (let i = 0; i < this.testStep.length; i++) {
              // this.testStep[i] = {
              //    stepIndex:''
              //   }
              this.testStep[i].stepIndex = i;
              this.testStep[i].viewS = true;
              ////this.testStep);
              this.visibleIndexForCardTip = this.testStepdata.teststepList.length;
              if(this.testStep[i].commandName == 'HITL')
              {
                  currentBranchIds = this.testStep[i].parameters.settingValue.split(",");
              }

            }
            // this.eBelow(this.parentStep.data,this.parentStep.data.stepIndex)
            this.testService.getBranchList(this.projectId,this.testId).subscribe((data)=>
              {
                this.allBranches = data
                this.currentBranches = this.allBranches.filter(item1 => currentBranchIds.some(item2 => item2 === item1.id)).map(item => ({ id: item.id, title: item.title }));
              })
          })
        // this.projectData = res;
        // this.headerOptions.data = {
        //   projectId: this.projectId,
        //   projectName: res['projectName']
        // };
        // this.inItFlowChart();
        // this.getFunction();
        // this.getBranches(this.projectId,this.testId);
      })
  }

  override ngOnInit(): void {
    this.initAllForms();
    console.log("children : ", this.data)
    this.branchCheck = this.data
    // this.compRef.instance.data = "Branch" + (this.canvas.flow.rootStep.children.length+1)
  }

  override canDrop(
    dropEvent: NgFlowchart.DropTarget,
    error: NgFlowchart.ErrorMessage
  ): boolean {
    console.log(dropEvent, error,this.data)
    this.parentStep = dropEvent.step.parent
    //BranchEnable
    if( this.branchCheck =='BranchEnable' && this.parentStep.data.parameters){
    this.route.paramMap.subscribe(
      params => {
        this.projectId = params.get('pid');
        this.testId = params.get('tid');
        this.testStepId = params.get('tsid')
        var res = JSON.parse(localStorage.getItem('projectDataById'));
        this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
        subscribe(
          (data) => {

            this.testStepdata = data;
            this.testStep = this.testStepdata.teststepList;
            this.testStepCopy = JSON.parse(JSON.stringify(this.testStep));
            for (let i = 0; i < this.testStep.length; i++) {
              // this.testStep[i] = {
              //    stepIndex:''
              //   }
              this.testStep[i].stepIndex = i;
              this.testStep[i].viewS = true;
              ////this.testStep);
              this.visibleIndexForCardTip = this.testStepdata.teststepList.length
              
              
            }
            // this.addBelow(this.parentStep.data,this.parentStep.data.stepIndex)
            console.log(this.canvas.flow.steps);
            this.compRef.instance.data = this.testStepdata.title + '/' +"HITL Branch-"  + (this.canvas.flow.rootStep.children.length+1)
            this.branchName = this.testStepdata.title + '/' +"HITL Branch-" + (this.canvas.flow.rootStep.children.length+1)
            if(this.canvas.flow.rootStep.children.length<6){
              this.createBranch(this.projectId,this.testId,this.branchName)
            }
            else{
              this.testService.shareTestSteps(this.testStep);
              this.toastrService.clear();
              this.toastrService.warning('Can not add more than 5 branches');
             
            }
          })
        // this.projectData = res;
        // this.headerOptions.data = {
        //   projectId: this.projectId,
        //   projectName: res['projectName']
        // };
        // this.inItFlowChart();
        // this.getFunction();
        // this.getBranches(this.projectId,this.testId);
      })
   
    // this.compRef.instance.data = "working"
    // console.log(this.compRef.instance.data);
    // console.log(this.compRef.instance.id);
    // console.log(this.canvas.flow.steps);
    // console.log(this.canvas.flow.rootStep);
    // console.log(this.canvas.flow.rootStep.children.length);
   
   
    return true;
    }
    else{
      this.toastrService.clear();
      this.toastrService.warning('You are dropping commands at wrong position')
      return false
    }
  }

  delete() {
    // let HITLlength = this.canvas.flow.rootStep.children.length;
    // if(HITLlength <= 2)
    // {
    //   this.toastrService.clear();
    //   this.toastrService.warning("Minimum 2 branches required for HITL");
    //   return;
    // }
    this.destroy(true);
  }
  createBranch(projectId,testSuiteId,branchName){

    var objectToUpdate = {
     "branch": [
         {
             "branch": branchName,
             "description": "This is branch two",
             "autoExecute":false
         },
     ]
 }
    this.testService.createBranch(projectId,testSuiteId,objectToUpdate).subscribe(
     (data)=>{
       console.log('branch created',data);
       this.testService.getBranchList(projectId,testSuiteId).subscribe((data)=>
      {
        this.allBranches = data
        this.newlyCreatedBranch = this.allBranches.find((newBranch)=>newBranch.title == branchName)
        console.log('branch created',this.newlyCreatedBranch);
        this.parentStep.data.parameters.settingValue = this.parentStep.data.parameters.settingValue + ',' + this.newlyCreatedBranch.id
        console.log(this.parentStep.data);
        this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
          subscribe(
            (data) => {

              this.testStepdata = data;
              this.testStep = this.testStepdata.teststepList;
              // this.testStepCopy = JSON.parse(JSON.stringify(this.testStep));
              this.addBelow(this.parentStep.data,this.parentStep.data.stepIndex)
            })
        
      })
     }
    )
   }
   addBelow(updateSteps, stepIndex) {
    
    this.testStepdata.teststepList[stepIndex] = updateSteps;
    ////"Create", result);
 
    const createTestStepData = this.testStepdata;
    ////createTestStepData);
    const myObject = createTestStepData[0];
    this.testService.editTestCase(this.projectId, this.testId, createTestStepData).
      subscribe((data) => {
        if (data) {
          ////"upDateData", data);
          this.testStepdata = data;
          this.testStep = this.testStepdata.teststepList;
          if(true){
            for (let i = 0; i < this.testStep.length; i++) {
              // this.testStep[i] = {
              //    stepIndex:''
              //   }
              this.testStep[i].stepIndex = i;
              this.testStep[i].viewS = true;
              ////this.testStep);
              this.visibleIndexForCardTip = this.testStepdata.teststepList.length
              
              
              
            }
            this.getLatestTestSteps();
          }
        }
      });
  }
  initAllForms()
  {
    this.stepRenameForm = this.formBuilder.group({
      stepName: ["", [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]],
      description: [""],
      autoExecute:[""]
    });
  }

  editBranch(value)
  {
    console.log("branch data, ", value)
    this.autoExecute=value.autoExecute
    console.log(this.data, value.title,value.autoExecute)
    this.stepRenameForm.patchValue({
      stepName: value.title,
      description: value.description == undefined ? "" :  value.description,
      autoExecute:value.autoExecute
    })
  }

  getLatestTestSteps()
  {
    this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
    subscribe(
      (data) => {
        this.testStepdata = data;
        this.testStep = [];
        this.testStep = this.testStepdata.teststepList;
        for (let i = 0; i < this.testStep.length; i++) {
          // this.testStep[i] = {
          //    stepIndex:''
          //   }
          this.testStep[i].stepIndex = i;
          this.testStep[i].viewS = true;

        }
       
          this.testService.shareTestSteps(this.testStep);
          setTimeout(() => {
          // this.testService.setStepForEdit(this.testStep[lastIndex])
        }, 1000);
       
      })
  }

  updateStep()
  {
    let check = false;
    this.currentBranches.forEach(element => {
        if(element.title == this.stepRenameForm.value.stepName && element.id != this.data["id"])
        {
          check = true;
        }
    });
    if(check)
    {
      this.toastrService.clear();
      this.toastrService.warning("Branch name already exist");
      return;
    }
    this.data['title'] = this.stepRenameForm.value.stepName;
    var objectForUpdate = {
          "branch": [
              {
                  "id":this.data['id'],
                  "branch": this.data['title'],
                  "description": this.stepRenameForm.value.description,
                  "autoExecute":this.autoExecute
              }
          ]
      }
    this.testService.updateBranch(this.projectId,this.testId,objectForUpdate).subscribe(
      (data)=>{
        console.log("branch data ",data, this.data, this.testStep);
        
      }
    )
    this.toastrService.clear();
    this.toastrService.success("Branch is updated successfully");
    this.getLatestTestSteps();

  }

  changeFlag(autoExecute){
   this.autoExecute = autoExecute;
   console.log(this.autoExecute);
   
  }
  deleteBranch(stepData,branchdata){
    console.log(stepData[0].data , this.testStepdata , branchdata);
    this.branchName = branchdata.title
    var stepIndex = stepData[0].data.stepIndex;
    var parameterToupdate = stepData[0].data.parameters.settingValue.split(",").filter((f)=>f != branchdata.id);
    if(parameterToupdate.length<2){
      this.toastrService.clear();
      this.toastrService.warning('You cannot delete this branch. An HITL step must contain minimum two branches.')
      return;
    }
    else{
      this.confirmationDialogService.openConfirmDialog('Are you sure you want to delete this branch from  HITL?')
            .afterClosed().subscribe(res => {
              if (res) {
              
                this.testStepdata.teststepList[stepIndex].parameters.settingValue = parameterToupdate.join();
                const createTestStepData = this.testStepdata;
                ////createTestStepData);
                this.http.post<any>(this.url + '/HuLoopRest/huloop/' + 'test/editTestCase/' + this.projectId + "/" + this.testId + '/false', createTestStepData).
                  subscribe((data) => {
                    if (data) {
                      ////"upDateData", data);
                      // this.checkAllTestSteps = false;
                      this.testStepdata = data;
                      this.testStep = [];
                      this.testStep = this.testStepdata.teststepList;
                      for (let i = 0; i < this.testStep.length; i++) {
                    
                        this.testStep[i].stepIndex = i;
                        this.testStep[i].viewS = true;
            
                      }
            
                        this.testService.shareTestSteps(this.testStep);
             
                      
                    }
                    this.testService.deleteBranch(this.projectId,this.testId,branchdata.id).subscribe(
                      (data)=>{
                        this.toastrService.clear();
                        this.toastrService.success('Branch is deleted successfully')
                      }
                    )
                  });
              }
            })
     
    }
    
    

  }

}

